import * as FileSaver from 'file-saver';
import { HttpResponse } from '@angular/common/http';
import { FileUploadPreviewMetadata } from '@edassist-ui/file-upload-preview';
import { constants } from '@edassist/common';

export class FileService {
	static saveFile(fileContents: any, fileName: string): void {
		FileSaver.saveAs(fileContents, fileName);
	}

	static getFileName(fileName: string, response: HttpResponse<any>): string {
		return response.headers.get('file-ext') ? fileName + response.headers.get('file-ext').toString() : fileName;
	}

	static getFile(response: HttpResponse<Blob>): Blob {
		const fileExtension = FileService.getMimeType(response.headers.get('content-type'));

		return new Blob([response.body], { type: fileExtension });
	}

	static getMimeType(mimeType: string): string {
		let extension: string;
		switch (mimeType) {
			case 'application/msword':
			case 'application/x-tika-msoffice':
				extension = 'application/msword';
				break;
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			case 'application/x-tika-ooxml':
				extension = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				break;
			default:
				extension = mimeType;
		}

		return extension;
	}

	static validateFiles(files: File[]): { validFiles: FileUploadPreviewMetadata[]; validationMessage?: string } {
		let validatedFiles: FileUploadPreviewMetadata[] = [];
		let validationMessage = '';

		files.forEach((file) => {
			const isFileSizeValid = file.size <= constants.FILE_VALIDATION.MAX_FILE_SIZE;
			const isFileTypeValid = constants.FILE_VALIDATION.SUPPORTED_MIME_TYPES.includes(file.type);

			if (!isFileSizeValid || !isFileTypeValid) {
				if (!isFileSizeValid && !isFileTypeValid) {
					validationMessage = ` File <strong>${file.name}</strong> exceeds the maximum size of 15 MB and is an unsupported file type.\n\n Please upload a smaller PDF, PNG, or JPEG file.`;
				} else if (!isFileSizeValid) {
					validationMessage = ` File <strong>${file.name}</strong> exceeds the maximum size of 15 MB.\n\n Please upload a smaller file to meet the size limit.`;
				} else {
					validationMessage = ` File <strong>${file.name}</strong> is an unsupported file type.\n\n Please upload a file in PDF (preferred), PNG, or JPEG format.`;
				}

				return;
			}

			validatedFiles.push({
				file,
				name: file.name,
				type: file.type,
				size: file.size,
				id: `file_${Date.now()}`
			} as FileUploadPreviewMetadata);
		});

		return { validFiles: validatedFiles, validationMessage: validationMessage };
	}
}
